import { handleRequest } from "../utilities/requestHandler";

/**
 * Load full product rows for a set of ids, priced for a site.
 *
 * @param {Array<number|string>} products Product ids.
 * @param {string} siteNumber Customer site number.
 * @param {Array<Object>} [lineItems] Optional [{product_id, machine_id}] pairs for per-line context.
 * @param {Object} [options]
 * @param {boolean} [options.resolveReplacements=false] Ask the server to attach each part's
 *   `replacement` (successor id, price, purchasable) so list rows can offer the replacement for
 *   sale. Off by default because the cart calls this with many ids.
 * @returns {Promise<Object>} `{ status, data }` envelope from handleRequest.
 */
export const getProductsById = (products, siteNumber, lineItems = [], { resolveReplacements = false } = {}) =>
    handleRequest("post", "/products/byids", {
        products: products,
        site_number: siteNumber,
        line_items: lineItems,
        resolve_replacements: resolveReplacements,
    });

export const getOptions = () =>
    handleRequest("get", "/options");

export const getCartRecommendations = (productIds, siteNumber) =>
    handleRequest("post", "/orders/getCartRecommendations", {
        products: productIds,
        site_number: siteNumber,
    });

export const getUserCart = (userId) =>
    handleRequest("post", "/cart/getCart", { userId });

export const updateUserCart = (userId, cart) =>
    handleRequest("post", "/cart", { userId, cart });

export const getCartCTP = (requestBody) =>
    handleRequest("post", "/erp/getCartCTP", requestBody);

export const addModelCartItems = (payload) =>
    handleRequest("post", "/cart/model_add_to_cart", payload);
